import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryOrders(
  {
    startAt,
    endAt,
    status,
    phone,
    page,
    size,
    direction,
    sort,
    orderNo,
    channel,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders`,
    method: 'get',
    params: {
      startAt,
      endAt,
      status,
      phone,
      page,
      size,
      direction,
      sort,
      orderNo,
      channel,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryOrderPosition(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/position`,
    method: 'get',
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}`,
    method: 'get',
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _shippedOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/shipped`,
    method: 'patch',
  });
}

/**
 * 更新
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _completedOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/completed`,
    method: 'patch',
  });
}

export function _refundOrder(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/refund`,
    method: 'post',
  });
}

export function _queryRefundOrders(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/refund-orders`,
    method: 'get',
  });
}

/**
 * 更新
 */
export function _updateOrderDeliverInfo(orderId, {
  city,
  name,
  district,
  address,
  province,
  zipCode,
  mobile,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/deliver-info`,
    method: 'patch',
    data: {
      city,
      name,
      district,
      address,
      province,
      zipCode,
      mobile,
    },
  });
}

export function _refundOrderDetail(orderId, refundData) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/refund/data`,
    method: 'post',
    data: refundData,
  });
}

/**
 * 备注
 * @param orderId
 * @param remark
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateOrderRemark(orderId, { remark }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/refund`,
    method: 'patch',
    data: {
      remark,
    },
  });
}

/**
 * 查询订单记录
 * @param orderId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _queryOrderRecords(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/${orderId}/records`,
    method: 'get',
  });
}

export function _addOrder(
  {
    firstName,
    lastName,
    country,
    town,
    street,
    phone,
    email,
    phonePrefix,
    postCode,
    location,
    channel,
    skuQualities,
    userId,
    payment,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/add`,
    method: 'post',
    data: {
      firstName,
      lastName,
      country,
      town,
      street,
      phone,
      email,
      phonePrefix,
      postCode,
      location,
      channel,
      skuQualities,
      userId,
      payment,
    },
  });
}

// 查询所有地区及货币
export function _queryLocation() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-orders/money-list`,
    method: 'get',
  });
}

export function _toAliPay(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/ali/create/${orderId}`,
    method: 'get',
  });
}

export function _toWxPay(orderId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/wx/createNative/${orderId}`,
    method: 'get',
  });
}

export default {};
